<router-outlet></router-outlet>

@if (isRouteLoading()) {
  <section class="app-loading" aria-live="polite" aria-busy="true">
    <div class="app-loading__content">
      <div class="app-loading__spinner" aria-hidden="true"></div>
      <h1>載入中</h1>
      <p class="app-loading__text">正在確認登入狀態與訂購權限，請稍候。</p>
    </div>
  </section>
}
